const parseUrlSSL = (url) => {
    const pattern = new RegExp('^https')
    if (pattern.test(url)) {
        return url
    }
    return `https://${url}`
}

export default parseUrlSSL
